// extracted by mini-css-extract-plugin
export default {"roleTableRow":"PhaseBudgetItemRow-module__roleTableRow___G_7WO"};